module.exports = __webpack_public_path__ + "media/images/front/toppage_cc_sp-d84d5de320b558579fbcf60612c68eb8.png";